<section class="section-gap innerBannerSetion">
  <div class="container">
    <h2><ng-content></ng-content></h2>
  </div>
</section>
